export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selection/empty.js
// module id = vyQh
// module chunks = 0